<template>
  <div class="img_store">
    <el-radio-group v-model="seClassification" v-if="$store.state.image_upload.showIconLibrary">
      <el-radio-button :label="item.type" v-for="(item,index) in classificationList"
                       :key="index">
        {{ item.type_name }}
      </el-radio-button>
    </el-radio-group>
    <template v-if="seClassification == 'img'">
      <div class="tabPart">
        <ul class="tablist clearfix">
          <li class="tabLine" v-for="item in typeList" :key="item.id" :class="{selected:item.id === pageParam.pid}"
              @click='changeParam(item.id)'>
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </div>
      <div class="imgPart" v-loading='isloading' v-if="typeList.length !== 0">
        <div class="imgContent">
          <ul class="clearfix-backup">
            <li class="imgLine" v-for="item in imgList" :key="item.id" @click="selectImg(item)">
              <div class="imgBox" :class="{selected:~selectImgList.indexOf(item.id)}">
                <img :src="item.path"/>
                <span class="activeIcon el-icon-check"></span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="noDataTip" v-if="typeList.length === 0">
        <p>{{$t('components_my_img_selecter_img_store_2353')}}</p>
      </div>
      <div class="page" v-if="typeList.length !== 0">
        <el-pagination
          popper-class="resource_page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageParam.page"
          :page-size="pageParam.rows"
          layout="total,sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100]"
          :total="total">
        </el-pagination>
      </div>
    </template>
    <template v-else>
      <fontIconStoreNew
        :limitnum="limitNumber"
        :firstModel.sync="checkList"></fontIconStoreNew>
    </template>
    <div class="img-store-footer">
      <el-button class="btn-footer-confirm" type="primary" size="small" @click="onClickConfirmBtn">{{$t('view_public_topbar_24')}}</el-button>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {getImgStore} from '@/api/app.js';
import fontIconStoreNew from './font_icon_store_new.vue'
import {uploadyunfile} from '@/api/app.js'

export default {
  data() {
    return {
      node_env: process.env.NODE_ENV,
      limitNumber: this.$store.state.image_upload.fileLimit,
      seClassification: this.seType,
      classificationList: [{
        type: 'img',
        isShow: true,
        type_name: i18n.t('view_download_index_180')
      },
        {
          type: 'icon',
          isShow: this.$store.state.image_upload.showIconLibrary,
          type_name: i18n.t('widgets_basic_footnav_edit_557')
        }],
      isloading: false,
      checkList: this.firstModel,
      selectImgList: [],
      typeList: [],
      imgList: [],
      total: 0,
      pageParam: {
        page: 1,
        rows: 20,
        pid: 0
      }
    };
  },
  computed: {
    isFileTab() {
      return this.$store.state.image_upload.fileType === this.$store.state.image_upload.TYPE_MY_FILE
    }
  },
  components: {
    fontIconStoreNew
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageParam.rows = val
      this.getImgStore()
    },
    handleCurrentChange(val) {
      this.pageParam.page = val
      this.getImgStore()
      console.log(`当前页: ${val}`);
    },
    changeParam(id) {
      this.pageParam.pid = id
      this.pageParam.page = 1
      this.getImgStore()
    },
    selectImg(item) {
      if (!~this.selectImgList.indexOf(item.id)) {
        if (this.checkList.length === this.limitnum && this.limitnum !== 1) {
          this.$message({
            message: i18n.t('components_my_img_selecter_font_icon_store_new_2322', [this.limitnum]),
            type: 'warning',
            customClass: 'zZindex'
          });
          return false
        }
        if (this.limitnum === 1) {
          this.selectImgList = []
          this.checkList = []
        }
        this.selectImgList.push(item.id)
        this.checkList.push(item)
      } else {
        this.selectImgList.splice(this.selectImgList.indexOf(item.id), 1)
        this.checkList = this.checkList.filter(e => {
          if (e.id !== item.id) {
            return e
          }
        })
      }
    },
    getTypeStore() {
      let data = {
        pid: 0
      };
      getImgStore(data).then(res => {
        if (res.code === 200) {
          this.typeList = res.data;
          if (this.typeList.length !== 0) {
            this.pageParam.pid = this.typeList[0].id;
            this.getImgStore();
          }
          console.log(res);
        }
      });
    },
    getImgStore() {
      let data = this.pageParam;
      this.isloading = true
      getImgStore(data).then(res => {
        if (res.code === 200) {
          this.imgList = []
          this.imgList = res.data.rows;
          this.total = res.data.total;
        }
      }).finally(() => {
        this.isloading = false
      });
    },
    onClickConfirmBtn() {
      if (![this.$store.state.image_upload.TYPE_IMG, this.$store.state.image_upload.TYPE_OTHER, this.$store.state.image_upload.TYPE_MY_FILE].includes(this.$store.state.image_upload.fileType)) {
        this.$message.warning(i18n.t('components_my_img_selecter_font_icon_store_2319'))
      }
      if (this.$store.state.image_upload.fileLimit < this.selectImgList.length) {
        this.$message.warning(i18n.t('components_my_img_selecter_font_icon_store_2320') + this.$store.state.image_upload.fileLimit + i18n.t('components_my_img_selecter_font_icon_store_2321'))
      }
      this.uploadImg()
    },
    async uploadImg() {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i].file && this.checkList[i].file !== null) {
          let param = new FormData()
          const f = this.checkList[i].file
          param.append('file', f)
          param.append('folderId', 0)
          await uploadyunfile(param).then(e => {
            if (e.code == 200 && e.data) {
              this.checkList[i] = e.data
            }
          })
        }
      }
      this.$store.state.image_upload.imgFile(this.checkList)
      this.closeDialog()
    },
    closeDialog() {
      this.$store.commit('image_upload/set_showTag', false);
      this.$store.commit("image_upload/set_showFontIcon", false);
      this.$store.commit("image_upload/set_showIconLibrary", false);
    }
  },
  props: {
    firstModel: {
      // 第一个字段的值（v-model)
      type: Array,
      default: function () {
        return []
      }
    },
    //最大数量
    limitnum: {
      type: Number,
      default: 1
    },
    seType: {
      // 第一个字段的值（v-model)
      type: String,
      default: 'img'
    },
  },
  watch: {
    checkList(val, oldVal) {
      // 数据双向绑定
      console.log(val)
      this.$emit('update:firstModel', val);
    },
    firstModel(val) {
      // 数据双向绑定
      this.checkList = val;
      this.selectImgList = val.map(e => {
        return e.id
      })
    },
    seClassification(val, oldVal) {
      this.checkList = []
      this.$emit('update:seType', val);
    },
    seType(val) {
      this.seClassification = val
    },
  },
  mounted() {
    this.getTypeStore();
  },
};
</script>

<style lang="scss" scoped>
.page {
  margin-top: 10px;
  text-align: center;
}

.img_store {
  font-size: 12px;
  min-width: 200px;
  padding: 10px 20px 10px 20px;

  .tabPart {
    margin-bottom: 17px;
    height: 12px;

    .tablist {
      overflow: hidden;
      padding: 0;
      margin: 0;
      margin-top: 20px;
      margin-right: -36px;
    }
  }

  .tabLine {
    line-height: 12px;
    float: left;
    margin-right: 28px;
    cursor: pointer;
  }

  .tabLine.selected {
    color: #557ce1
  }

  .noDataTip {
    height: 380px;
    line-height: 380px;
    text-align: center;
    font-size: 30px;
  }

  .imgPart {

    .imgContent {
      height: 380px;
      overflow-y: auto;
    }

    .imgLine {
      float: left;
      margin-right: 24px;
      margin-top: 27px;
      list-style: none;
    }

    .imgBox {
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 116px;
      height: 116px;
      background: #f3f3f3;

      img {
        max-width: 100%;
        max-height: 100%;
        min-width: 1px;
        min-height: 1px;
        width: auto;
        height: auto;
      }

      .activeIcon {
        display: none;
        width: 18px;
        height: 16px;
        color: #fff;
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: #5874d8;
        line-height: 22px;
        font-size: 12px;
        padding: 0 3px;
        border-top-left-radius: 100%;
      }
    }

    .imgBox.selected {
      border: 1px solid #5874d8;

      .activeIcon {
        display: block;
      }
    }

    .imgBox:hover {
      border: 1px solid #5874d8;
    }
  }
}

.showPart {
  padding: 30px 30px 20px 28px;
}

.img-store-footer {
  display: flex;
  justify-content: flex-end;
}

.btn-footer-confirm {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_img_selecter/img_store.vue